import store from './store/store';
import {
    FirebaseContext,
    FirebaseProvider
} from './config/configureFirebase';
import * as authactions from './actions/authactions';
import * as bookingactions from './actions/bookingactions';
import * as bookinglistactions from './actions/bookinglistactions';
import * as cancelreasonactions from './actions/cancelreasonactions';
import * as cartypeactions from './actions/cartypeactions';
import * as estimateactions from './actions/estimateactions';
import * as driverearningaction from './actions/driverearningaction';
import * as earningreportsaction from './actions/earningreportsaction';
import * as notificationactions from './actions/notificationactions';
import * as promoactions from './actions/promoactions';
import * as usersactions from './actions/usersactions';
import * as settingsactions from './actions/settingsactions';
import * as paymentactions from './actions/paymentactions';
import * as tripactions from './actions/tripactions';
import * as taskactions from './actions/taskactions';
import * as locationactions from './actions/locationactions';
import * as chatactions from './actions/chatactions';
import * as withdrawactions from './actions/withdrawactions';
import * as DateFunctions from './other/DateFunctions';
import * as GoogleAPIFunctions from './other/GoogleAPIFunctions';
import * as GeoFunctions from './other/GeoFunctions';
import * as RouteCostControl from './other/RouteCostControl';
import economyConfig from './config/economyConfig';
import * as economyLogger from './other/economyLogger';
import * as locationThrottler from './other/locationThrottler';
import * as LiveVehicleTracking from './other/LiveVehicleTracking';
import * as NearbyDriverSearch from './other/NearbyDriverSearch';
import * as languageactions from './actions/languageactions';
import * as addressactions from './actions/addressactions';
import * as NotificationFunctions from './other/NotificationFunctions';
import * as caractions from './actions/caractions';
import * as smtpactions from './actions/smtpactions';
import * as smsactions from './actions/smsactions';
import countries from './other/GetCountries';
import * as sosctions from './actions/sosaction';
import * as complainactions from './actions/complainactions';
import * as userreportactions from './actions/userreportactions';
import * as userblockactions from './actions/userblockactions';
import * as usedreferralaction from "./actions/usedreferralaction";
import * as fetchFleetAdminEarnings from "./actions/fleetadminearningaction";
import * as vietnameseFunctions from './other/vietnameseFunctions';
import { FareCalculator } from './other/FareCalculator';
import * as bankDetailsHelper from './other/bankDetailsHelper';
import * as autoRechargeApi from './other/autoRechargeApi';
import { USER_REPORT_REASONS, getOtherPartyFromBooking, filterDriversExcludingBlocks, getBlockedDriverIdsFromMap } from './other/userSafetyHelpers';
import { moderateChatMessage } from './other/chatModeration';

const api = {
    FareCalculator,
    ...authactions,
    ...bookingactions,
    ...bookinglistactions,
    ...cancelreasonactions,
    ...cartypeactions,
    ...estimateactions,
    ...driverearningaction,
    ...earningreportsaction,
    ...notificationactions,
    ...promoactions,
    ...usersactions,
    ...settingsactions,
    ...paymentactions,
    ...tripactions,
    ...taskactions,
    ...locationactions,
    ...addressactions,
    ...chatactions,
    ...withdrawactions,
    ...DateFunctions,
    ...GoogleAPIFunctions,
    ...GeoFunctions,
    ...RouteCostControl,
    economyConfig,
    ...economyLogger,
    ...locationThrottler,
    ...LiveVehicleTracking,
    ...NearbyDriverSearch,
    ...languageactions,
    ...NotificationFunctions,
    ...caractions,
    ...complainactions,
    ...userreportactions,
    ...userblockactions,
    filterDriversExcludingBlocks,
    getBlockedDriverIdsFromMap,
    ...smtpactions,
    ...smsactions,
    ...sosctions,
    ...usedreferralaction,
    ...fetchFleetAdminEarnings,
    ...vietnameseFunctions,
    ...bankDetailsHelper,
    ...autoRechargeApi,
    countries: countries
};

export {
    FirebaseContext,
    FirebaseProvider,
    store,
    api,
    USER_REPORT_REASONS,
    getOtherPartyFromBooking,
    filterDriversExcludingBlocks,
    getBlockedDriverIdsFromMap,
    moderateChatMessage,
}